<template>
  <section class="product-card" @click="showDetail">
    <section class="header">
      <img
        src="/images/icons/hidden.svg"
        v-if="!packet.active"
        class="hidden-icon"
      />
      <is-in-cart :item="packet" class="cart-indicator"></is-in-cart>

      <template v-if="isOwnPrintStore(value.printStoreId)">
        <authorization-component print-store-role="ADMIN" class="kebab">
          <popup-menu anchor-position="top-right">
            <button class="kebab-btn" slot="trigger"><span></span></button>
            <menu-item @click="edit()">Wijzigen</menu-item>
            <menu-item @click="remove()">Verwijderen</menu-item>
          </popup-menu>
        </authorization-component>
      </template>
    </section>
    <card-image :images="images" type="package" class="card-image"></card-image>
    <card-text
      :name="packet.name"
      type="package"
      :count="packet.itemCount"
    ></card-text>
  </section>
</template>

<script>
import CardText from '@/features/printstore/children/CardText.vue'
import CardImage from '@/features/printstore/children/CardImage.vue'
import IsInCart from '@/features/printstore/children/IsInCart.vue'
import PrintStoreMixin from '@/features/printstore/PrintStoreMixin'
import EditPackage from '@/features/printstore/dialogs/EditPackage.vue'
import { getPackage } from '@/features/printstore/PrintStoreApi'

export default {
  name: 'PackageCard',
  components: {
    IsInCart,
    CardText,
    CardImage
  },
  mixins: [PrintStoreMixin],
  props: ['value'],
  data() {
    return {
      packet: this.value
    }
  },
  computed: {
    images() {
      if (this.packet.previewImage) {
        return [
          {
            id: this.packet.previewImage,
            printStoreId: this.packet.printStoreId
          }
        ]
      } else if (this.packet.products) {
        return this.packet.products
          .map((product) => {
            let image = product.previewImage
              ? product.previewImage
              : product.variant.previewImage

            return {
              id: image,
              printStoreId: this.value.printStoreId
            }
          })
          .slice(0, 4)
      } else if (this.packet.images) {
        return this.packet.images
          .map((image) => {
            return {
              printStoreId: this.packet.printStoreId,
              id: image
            }
          })
          .slice(0, 4)
      } else {
        return []
      }
    }
  },
  methods: {
    async showDetail() {
      let thePackage = await getPackage(this.value.id)

      this.$router.push({
        name: 'printStorePackage',
        params: {
          categoryId: thePackage.categoryId,
          packageId: this.value.id,
          thePackage: thePackage
        }
      })
    },
    async edit() {
      this.$modal.show(
        EditPackage,
        {
          package: await getPackage(this.value.id),
          callback: async (modifiedPackage) => {
            this.packet = modifiedPackage
          }
        },
        {
          adaptive: true,
          width: 480
        }
      )
    },
    remove: function () {
      this.deletePackage(this.value.id, this.value.name).then(() =>
        this.$emit('removed')
      )
    }
  }
}
</script>

<style scoped>
.hidden-icon {
  margin-left: 4px;
  margin-top: 4px;
}
</style>
